import React, { useState } from 'react';
import {
    TextField,
    Grid,
    InputAdornment,
    Button
} from '@mui/material';
import {
    Person as PersonIcon,
    Email as EmailIcon,
    Phone as PhoneIcon,
    Save as SaveIcon
} from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { isAlphaKey, isEmailChar, isNumberKey } from '../../../mobile/mobileComponents/mobileUserAccountLogin/userAccoountHook';
import { saveReceiverUserDetails } from '../../../store/giftcardDesign/action';

const ReceiverDetailsSection = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: ''
    });
    const [errors, setErrors] = useState({
        name: false,
        email: false,
        phone: false
    });

    const [isSavedDetails, setIsSavedDetails] = useState(false);
    const dispatch = useDispatch();

    const editUserDetails = () => {
        if (isSavedDetails) {
            setIsSavedDetails(false);
        }
    }

    const validateAndSave = () => {
        // Basic validation
        const newErrors = {
            name: formData.name.trim().length < 3,
            email: !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email),
            phone: !/^[0-9]{10,15}$/.test(formData.phone)
        };

        setErrors(newErrors);

    if (!Object.values(newErrors).some(error => error)) {
        dispatch(saveReceiverUserDetails({
                name: formData.name.trim(),
                email: formData.email.trim(),
                phone: formData.phone.trim()
            }));
            setIsSavedDetails(true);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let filteredValue = '';

        // Process each character using ASCII validation
        for (let char of value) {
            let isValid = false;

            switch (name) {
                case 'name':
                    isValid = isAlphaKey(char) ||
                        (char === ' ' && filteredValue.slice(-1) !== ' ');
                    break;
                case 'email':
                    isValid = isEmailChar(char);
                    break;
                case 'phone':
                    isValid = isNumberKey(char);
                    break;
            }

            if (isValid) filteredValue += char;
        }

        setFormData(prev => ({
            ...prev,
            [name]: filteredValue
        }));
    };


    return (
        <Grid container spacing={2} sx={{ py: 2 }}>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Full Name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    disabled={isSavedDetails}
                    error={errors.name}
                    helperText={errors.name ? 'Minimum 3 characters required' : ''}
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><PersonIcon /></InputAdornment>,
                    }}
                    inputProps={{ maxLength: 50 }}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Email Address"
                    name="email"
                    type="email"
                    value={formData.email}
                    disabled={isSavedDetails}
                    onChange={handleInputChange}
                    error={errors.email}
                    helperText={errors.email ? 'Please enter a valid email' : ''}
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><EmailIcon /></InputAdornment>,
                    }}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Phone Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    disabled={isSavedDetails}
                    error={errors.phone}
                    helperText={errors.phone ? '10-15 digits required' : ''}
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><PhoneIcon /></InputAdornment>,
                    }}
                    inputProps={{
                        maxLength: 10,  // Changed from 15 to 10
                        inputMode: 'numeric',  // Better mobile keyboard
                        pattern: '[0-9]{10}'  // HTML5 validation
                    }}
                />
            </Grid>

            <Grid item xs={12}>
                <Button
                    variant='contained'
                    startIcon={<SaveIcon />}
                    onClick={() => isSavedDetails ? editUserDetails() : validateAndSave()}
                    sx={{
                        py: 1.5,
                        width: 230,
                        fontSize: '1.1rem',
                        fontWeight: 500,
                        textTransform: 'none'
                    }}
                >
                    {isSavedDetails ? "Edit Details" : "Save Details"}
                </Button>
            </Grid>
        </Grid>
    );
};

export default ReceiverDetailsSection;